import React from 'react';
import { Crown, Database, ShoppingCart, Landmark, Factory, ArrowRight } from 'lucide-react';
import templateLibrary from '../data/templates';

const iconMap = {
  shopping: ShoppingCart,
  finance: Landmark,
  ops: Factory
};

const Templates = ({ selectedFile, onUseQuestion, onLoadSample }) => {
  const hasDataset = Boolean(selectedFile);

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      <div className="card">
        <div className="flex items-start justify-between gap-4">
          <div>
            <h2 className="text-xl font-semibold text-ink">Premium Templates</h2>
            <p className="text-sm text-sand-700 mt-1">
              Use curated question packs to jump-start analysis.
            </p>
          </div>
          <div className="flex items-center gap-2 text-xs text-sand-600">
            <Crown className="w-4 h-4 text-bill-600" />
            Pro templates included in preview
          </div>
        </div>
      </div>

      {!hasDataset && (
        <div className="card border border-bill-300 bg-bill-100">
          <div className="flex items-start gap-3">
            <div className="p-2 bg-bill-200 rounded-lg">
              <Database className="w-5 h-5 text-bill-600" />
            </div>
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-ink">Select a dataset</h3>
              <p className="text-sm text-sand-700 mt-1">
                Templates work best when a dataset is loaded. Upload a file or use the sample dataset.
              </p>
              {onLoadSample && (
                <button
                  type="button"
                  onClick={onLoadSample}
                  className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-bill-500 text-white hover:bg-bill-600 shadow-brand-sm text-sm transition-colors"
                >
                  Load sample dataset
                  <ArrowRight className="w-4 h-4" />
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {templateLibrary.map((template) => {
          const Icon = iconMap[template.icon] || Database;
          return (
            <div key={template.id} className="card space-y-4">
              <div className="flex items-start justify-between">
                <div className="flex items-center gap-3">
                  <div className="p-2 bg-sand-100 rounded-lg border border-[rgba(32,30,29,0.12)]">
                    <Icon className="w-5 h-5 text-bill-600" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-ink">{template.title}</h3>
                    <p className="text-sm text-sand-700">{template.description}</p>
                  </div>
                </div>
                {template.premium && (
                  <span className="inline-flex items-center gap-1 text-xs text-bill-700 bg-bill-100 border border-bill-300 rounded-full px-2 py-1">
                    <Crown className="w-3 h-3" />
                    Pro
                  </span>
                )}
              </div>

              <div>
                <div className="text-xs text-sand-600 mb-2">Recommended columns</div>
                <div className="flex flex-wrap gap-1.5">
                  {template.recommendedColumns.map((column) => (
                    <span
                      key={column}
                      className="px-2 py-1 bg-sand-100 text-sand-700 text-xs rounded border border-[rgba(32,30,29,0.12)]"
                    >
                      {column}
                    </span>
                  ))}
                </div>
              </div>

              <div className="space-y-2">
                {template.questions.map((item) => (
                  <button
                    key={item.question}
                    type="button"
                    onClick={() => onUseQuestion && onUseQuestion(item.question)}
                    disabled={!hasDataset}
                    className="w-full text-left px-3 py-2 rounded-lg border border-[rgba(32,30,29,0.12)] bg-white hover:bg-sand-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                    <div className="text-sm text-ink">{item.question}</div>
                    <div className="text-xs text-sand-600 mt-1">{item.description}</div>
                  </button>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Templates;
